import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col } from "react-bootstrap"

/* UTILS or HELPERS */
import { convertToRupiah, getCloudImageUrl } from "../../../../utils"
import { DEFAULT_CREDIT_CARD } from "../../../../constants/paymentMethods"

/* ASSETS */
import CircleBack from "../../../../images/circle-back.png";
import ArrowsNext from "../../../../images/arrowsNext.png";

const ArrowsNextIcon: any = ArrowsNext
const CircleBackIcon: any = CircleBack

interface balanceUsage {
  kickPoint: 0,
  kickCredit: 0,
  sellerCredit: 0,
  remainingPayment: 0,
}

interface paymentMethod {
  type: string;
  logo: string;
  label: string;
  active: boolean;
  payment_group: number;
  payment_method: string;
}

interface kredivoInstallment {
  label: string
  monthly_installment: number
  value: string
}

type AddPaymentMethodProps = {
  dataAkulaku: Array<Object>
  balanceUsage: balanceUsage
  isIndonesian: boolean
  isResponsive: boolean
  availableMethods: Array<paymentMethod>
  _installmentsList: Array<kredivoInstallment>
  setKickCreditProcess: (args: string) => void
  setSelectedSplitPaymentMethod: (args: paymentMethod | kredivoInstallment | null) => void
}

const AddPaymentMethod: React.FC<AddPaymentMethodProps> = ({
  dataAkulaku,
  balanceUsage,
  isIndonesian,
  isResponsive,
  availableMethods,
  _installmentsList,
  setKickCreditProcess,
  setSelectedSplitPaymentMethod
}): JSX.Element => {
  return (
    <Col className="payment-right-bag-content">
      <div className="payment-list-scroll">
        <Row className="choose-payment-type">
          <Col
            className="icon-wrapper"
            onClick={() => {
              setKickCreditProcess("")
              setSelectedSplitPaymentMethod(null)
            }}
          >
            <KickImage src={CircleBackIcon} alt="..." />
          </Col>
          <Col className="text">
            <p>Add Payment</p>
          </Col>
        </Row>
        <Row className="amount-to-be-paid">
          <p>Remaining payment</p>
          <p>IDR. {convertToRupiah(balanceUsage.remainingPayment)}</p>
        </Row>
        <Row className="kick-credit-payment-wrapper">
          <div className="title-text-wrapper">
            <p>Credit Card</p>
            <p>
              Your payment will be verified automatically by the
              payment gateway.
            </p>
          </div>
          {availableMethods.map((item) => {
            if (
              item.payment_group === 1 &&
              item.type === "credit_card"
            ) {
              const isNotDisable =
                (item.active && isIndonesian) ||
                (!isIndonesian &&
                  item.payment_method === DEFAULT_CREDIT_CARD);
              return (
                <Row
                  onClick={() => {
                    if (isNotDisable) {
                      setSelectedSplitPaymentMethod(item);
                      setKickCreditProcess("");
                    }
                  }}
                  className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable ? "" : "disabled"
                    }`}
                >
                  <Col className="icon-wrapper">
                    {item.logo && (
                      <KickImage
                        src={getCloudImageUrl(item.logo)}
                        alt="..."
                      />
                    )}
                  </Col>
                  <Col className="text-wrapper">
                    <p>{item.label}</p>
                  </Col>
                  <Col className="arrow-wrapper">
                    <KickImage src={ArrowsNextIcon} alt="..." />
                  </Col>
                </Row>
              );
            }
          })}
        </Row>
        <Row className="kick-credit-payment-wrapper">
          <div className="title-text-wrapper">
            <p>Virtual Acccount</p>
            <p>
              Your payment will be verified automatically by the
              payment gateway.
            </p>
          </div>
          {availableMethods.map((item) => {
            if (
              item.payment_group === 1 &&
              item.type === "virtual_account"
            ) {
              const isNotDisable = item.active && isIndonesian;
              return (
                <Row
                  onClick={() => {
                    if (isNotDisable) {
                      setSelectedSplitPaymentMethod(item);
                      setKickCreditProcess("");
                    }
                  }}
                  className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable ? "" : "disabled"
                    }`}
                >
                  <Col className="icon-wrapper">
                    {item.logo && (
                      <KickImage
                        src={getCloudImageUrl(item.logo)}
                        alt="..."
                      />
                    )}
                  </Col>
                  <Col className="text-wrapper">
                    <p>{item.label}</p>
                  </Col>
                  <Col className="arrow-wrapper">
                    <KickImage src={ArrowsNext} alt="..." />
                  </Col>
                </Row>
              );
            }
          })}
        </Row>
        {/* <Row className="kick-credit-payment-wrapper">
          <div className="title-text-wrapper">
            <p>Bank Transfer - Manual Verification</p>
            <p>
              Please allow 1 working day for us to verify your
              payment.
            </p>
          </div>
          {availableMethods.map((item) => {
            if (
              item.payment_group === 1 &&
              item.type === "bank_transfer"
            ) {
              const isNotDisable = item.active && isIndonesian;
              return (
                <Row
                  onClick={() => {
                    if (isNotDisable) {
                      setSelectedSplitPaymentMethod(item);
                      setKickCreditProcess("");
                    }
                  }}
                  className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable ? "" : "disabled"
                    }`}
                >
                  <Col className="icon-wrapper">
                    {item.logo && (
                      <KickImage
                        src={getCloudImageUrl(item.logo)}
                        alt="..."
                      />
                    )}
                  </Col>
                  <Col className="text-wrapper">
                    <p>{item.label}</p>
                  </Col>
                  <Col className="arrow-wrapper">
                    <KickImage src={ArrowsNext} alt="..." />
                  </Col>
                </Row>
              );
            }
          })}
        </Row> */}
        <Row className="kick-credit-payment-wrapper">
          <div className="title-text-wrapper">
            <p>Non-CC Installment</p>
            <p>
              Your payment will be verified automatically by the
              payment gateway.
            </p>
          </div>
          {availableMethods.map((item) => {
            if (item.payment_group === 2) {
              const isNotDisable =
                item.active &&
                balanceUsage.remainingPayment >= 100000 &&
                isIndonesian;
              switch (item.payment_method) {
                case "atome":
                  return (
                    <Row
                      onClick={() => {
                        if (isNotDisable) {
                          setSelectedSplitPaymentMethod(item);
                          setKickCreditProcess("split-atome-as-payment");
                        }
                      }}
                      className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable ? "" : "disabled"
                        }`}
                    >
                      <Col className="icon-wrapper">
                        {item.logo && (
                          <KickImage
                            src={getCloudImageUrl(item.logo)}
                            alt="..."
                          />
                        )}
                      </Col>
                      <Col className="text-wrapper">
                        <p>{item.label}</p>
                      </Col>
                      <Col className="arrow-wrapper">
                        <KickImage src={ArrowsNextIcon} alt="..." />
                      </Col>
                    </Row>
                  );
                case "kredivo":
                  const kredivoData =
                    _installmentsList.length &&
                    _installmentsList.length > 0;
                  return (
                    <Row
                      onClick={() => {
                        if (isNotDisable && kredivoData) {
                          setSelectedSplitPaymentMethod(item);
                          setKickCreditProcess(
                            "split-kredivo-as-payment"
                          );
                        }
                      }}
                      className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable && kredivoData ? "" : "disabled"
                        }`}
                    >
                      <Col className="icon-wrapper">
                        {item.logo && (
                          <KickImage
                            src={getCloudImageUrl(item.logo)}
                            alt="..."
                          />
                        )}
                      </Col>
                      <Col className="text-wrapper">
                        <p>{item.label}</p>
                      </Col>
                      <Col className="arrow-wrapper">
                        <KickImage src={ArrowsNextIcon} alt="..." />
                      </Col>
                    </Row>
                  );
                case "akulaku":
                  const akulakuData =
                    dataAkulaku.length && dataAkulaku.length > 0;
                  return (
                    <Row
                      onClick={() => {
                        if (isNotDisable && akulakuData) {
                          setSelectedSplitPaymentMethod(item);
                          setKickCreditProcess("split-akulaku-as-payment");
                        }
                      }}
                      className={`payment-list-wrapper virtual-account-wrapper ${isNotDisable && akulakuData ? "" : "disabled"
                        }`}
                    >
                      <Col className="icon-wrapper">
                        {item.logo && (
                          <KickImage
                            src={getCloudImageUrl(item.logo)}
                            alt="..."
                          />
                        )}
                      </Col>
                      <Col className="text-wrapper">
                        <p>{item.label}</p>
                      </Col>
                      <Col className="arrow-wrapper">
                        <KickImage src={ArrowsNextIcon} alt="..." />
                      </Col>
                    </Row>
                  );
              }
            }
          })}
        </Row>
      </div>
    </Col>
  )
}

export default AddPaymentMethod